export function ecart(quantitePhysique, quantiteNumerique) {
    if (quantitePhysique === null || quantitePhysique === '' || quantitePhysique === undefined) {
        return null
    }
    return Number(quantitePhysique) - Number(quantiteNumerique || 0)
}

export function ecartLabel(value) {
    if (value === null || Number.isNaN(value)) return '\u2014'
    return value > 0 ? `+ ${value}` : `${value}`
}

export function ecartClass(value) {
    if (value === null || Number.isNaN(value) || value === 0) {
        return 'badge badge-xs badge-success-light'
    }
    return value > 0 ? 'badge badge-xs badge-primary-light' : 'badge badge-xs badge-danger-light'
}

export function errorMessage(error, fallback) {
    return error?.response?.data?.message || fallback
}

export function toNumber(value) {
    const n = Number(value)
    return Number.isFinite(n) ? n : 0
}

export function formatMoney(value, currency = '') {
    if (value === null || value === undefined || value === '') return '\u2014'
    const n = Number(value)
    if (!Number.isFinite(n)) return '\u2014'
    const formatted = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(n)
    return currency ? `${formatted} ${currency}` : formatted
}

export function formatSignedMoney(value, currency = '') {
    if (value === null || value === undefined || value === '') return '\u2014'
    const n = Number(value)
    if (!Number.isFinite(n)) return '\u2014'
    const formatted = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(Math.abs(n))
    const suffix = currency ? ` ${currency}` : ''
    if (n > 0) return `+ ${formatted}${suffix}`
    if (n < 0) return `- ${formatted}${suffix}`
    return `0${suffix}`
}
